import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Auth from '@aws-amplify/auth';
import ProjectListPage from '../views/ProjectListPage.vue';
import ProjectSearchDocsDashboard from '@/views/ProjectSearchDocsDashboard.vue';
import ProjectSavedResultsPage from '@/views/ProjectSavedResultsPage.vue';
import NotificationsPage from '../views/NotificationsPage.vue';
import LabelComparisonPage from '@/views/LabelComparisonPage.vue';
import TimelinesPage from '@/views/TimelinePage.vue';
import ProductsTablePage from '@/views/ProductsTablePage.vue';
import {
  isCompareLabelsUngated,
  isProductTablesUngated,
  isTimelinesUngated,
} from '@/constants/gates';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  ...(isCompareLabelsUngated
    ? [
        {
          path: '/label-comparison',
          name: 'LabelComparisonPage',
          props: true,
          component: LabelComparisonPage,
          meta: {
            requiresAuth: true,
          },
        },
      ]
    : []),
  ...(isTimelinesUngated
    ? [
        {
          path: '/timelines',
          name: 'TimelinesPage',
          props: true,
          component: TimelinesPage,
          meta: {
            requiresAuth: true,
          },
        },
      ]
    : []),
  ...(isProductTablesUngated
    ? [
        {
          path: '/product-tables',
          name: 'ProductsTablePage',
          props: true,
          component: ProductsTablePage,
          meta: {
            requiresAuth: true,
          },
        },
      ]
    : []),
  {
    path: '/project-searchdocs-dashboard',
    name: 'ProjectSearchDocsDashboard',
    component: ProjectSearchDocsDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/project-list',
    name: 'ProjectListPage',
    component: ProjectListPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:id/saved-results',
    name: 'results',
    props: true,
    component: ProjectSavedResultsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    props: true,
    component: NotificationsPage,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // using current user info ensures that disabling the user will prevent
    // access to any new navigation immediately
    Auth.currentUserInfo()
      .then((user) => {
        // user is present but has been disabled
        if (Object.keys(user).length === 0) {
          localStorage.clear();
          next({ name: 'Home' });
        } else next();
      })
      .catch(() => {
        localStorage.clear();
        next({ name: 'Home' });
      });
  } else {
    Auth.currentUserInfo()
      .then((user) => {
        // user is present but has been disabled

        if (Object.keys(user).length === 0) {
          localStorage.clear();
          if (to.name !== 'Home') next({ name: 'Home' });
          else next();
        } else {
          next({
            name: 'ProjectSearchDocsDashboard',
          });
        }
      })
      .catch(() => {
        localStorage.clear();
        if (to.name !== 'Home') next({ name: 'Home' });
        else next();
      });
  }
});

export default router;
